import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

import { GameCenterComponentGridAreas, Section, SectionContainer } from '../../../../styles';

import { PregameComponentFlags } from './utils';

const GRID_TEMPLATE_AREAS = ($pregameComponentFlags: PregameComponentFlags) =>
    [
        $pregameComponentFlags.isGamePreviewVisible ? GameCenterComponentGridAreas.gamePreview : '',
        $pregameComponentFlags.isPlayersToWatchVisible ? GameCenterComponentGridAreas.playersToWatch : '',
        $pregameComponentFlags.isGoalieComparisonVisible ? GameCenterComponentGridAreas.goalieComparison : '',

        GameCenterComponentGridAreas.teamRoster,
        window.__AD_SETTINGS__.mrecDivId ? GameCenterComponentGridAreas.ad : '',
        GameCenterComponentGridAreas.seasonSeries,
        GameCenterComponentGridAreas.teamStats,
        GameCenterComponentGridAreas.lastTenOrPlayoffsRecord,
        GameCenterComponentGridAreas.gameInfoReports,
    ]
        .filter((item) => item)
        .map((item) => `'${item}'`)
        .join('\n');

export const PregameContainer = styled(SectionContainer)<{ $pregameComponentFlags: PregameComponentFlags }>`
    grid-template-areas: ${({ $pregameComponentFlags }) => GRID_TEMPLATE_AREAS($pregameComponentFlags)};

    ${BaseStyle.Mixins.screenSizes.large} {
        grid-template-areas: '${GameCenterComponentGridAreas.mainContent} ${GameCenterComponentGridAreas.rightRail}';
    }
`;

export const MainContent = styled(Section)`
    grid-area: ${GameCenterComponentGridAreas.mainContent};
`;

export const RightRail = styled(Section)`
    grid-area: ${GameCenterComponentGridAreas.rightRail};

    border-radius: 4px;
    border: 1px solid ${({ theme }) => theme.Surface.border};
    padding: 24px 0;
    height: fit-content;
`;
